import React from "react"
import { useParams } from "react-router-dom"
import { EDIT } from "../../include/constant"
import ProductForm from "../common/ProductForm"
import AdminHeader from "./Header"

const AdminEditProduct = () => {
    const { id } = useParams()
    return <div className="fixed-top-bar">
        <AdminHeader />
        <ProductForm
            id={id}
            title="Add Product"
            type={EDIT}
        />
    </div>
}

export default AdminEditProduct